function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M112.068,238.933H94.775a.91.91,0,1,0,0,1.82h17.293a.91.91,0,0,0,0-1.82Z",
  transform: "translate(-88.404 -213.449)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M112.068,281.6H94.775a.91.91,0,1,0,0,1.82h17.293a.91.91,0,0,0,0-1.82Z",
  transform: "translate(-88.404 -251.565)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M112.068,324.267H94.775a.91.91,0,1,0,0,1.82h17.293a.91.91,0,0,0,0-1.82Z",
  transform: "translate(-88.404 -289.682)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M106.607,366.933H94.775a.91.91,0,1,0,0,1.82h11.832a.91.91,0,0,0,0-1.82Z",
  transform: "translate(-88.404 -327.797)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M106.607,409.6H94.775a.91.91,0,0,0,0,1.82h11.832a.91.91,0,0,0,0-1.82Z",
  transform: "translate(-88.404 -365.913)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M87.845,9.312,76.923.211a.911.911,0,0,0-1.165,0L67.273,7.281H45.4a2.733,2.733,0,0,0-2.73,2.73V51.879a2.733,2.733,0,0,0,2.73,2.73H65.419a.919.919,0,0,0,.644-.267L78.8,41.6l0,0a.9.9,0,0,0,.174-.258.881.881,0,0,0,.031-.086.9.9,0,0,0,.049-.24c0-.02.011-.036.011-.056v-9.1h1.82a2.733,2.733,0,0,0,2.73-2.73v-18.2h3.641a.91.91,0,0,0,.583-1.61ZM66.329,51.5V42.777a.911.911,0,0,1,.91-.91h8.725ZM77.251,40.047H67.239a2.733,2.733,0,0,0-2.73,2.73V52.789H45.4a.911.911,0,0,1-.91-.91V10.012a.911.911,0,0,1,.91-.91H65.089l-.253.211a.91.91,0,0,0,.583,1.61h3.641v18.2a2.733,2.733,0,0,0,2.73,2.73h5.461v8.191ZM82.711,9.1a.91.91,0,0,0-.91.91V29.125a.911.911,0,0,1-.91.91h-9.1a.911.911,0,0,1-.91-.91V10.012a.91.91,0,0,0-.91-.91H67.933L76.34,2.1,84.748,9.1H82.711Z",
  transform: "translate(-42.665 0)"
})));

function SvgSubir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.508,
    viewBox: "0 0 45.508 54.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubir);
export default __webpack_public_path__ + "static/media/Subir.06cbf3fe.svg";
export { ForwardRef as ReactComponent };